<div class="container flex center column">
    <h3 class="testimonial-title">{{'landing-page.testimonials_title' | translateWithKeys}}</h3>
    <div>
        <div class="testimonial-container flex center column">
            <img class="image" src="../../../../assets/images/placeholder_testimonials.jpg" alt="">
            <!-- TODO: Replace with dynamic data -->
            <p class="testimonial">"Gracias a esta plataforma, entendí cómo mejorar mi posicionamiento en el campo. ¡Ahora lidero mi equipo con confianza"</p>
            <div class="flex center column">
                <h4 class="name">Juan P.</h4>
                <p class="position">Capitán Sub-21</p>
            </div>
        </div>
    </div>
</div>
